import ReactEcharts from "echarts-for-react";
import { useAppContext } from "../../../shared/contexts/app-context/components/AppContext";
import { chartDataSourceService } from "../utils/ChartDataSourceService";
import { chartDataSeriesService } from "../utils/ChartDataSeriesService";
import { useEffect } from "react";
import { AssetType } from "../../../shared/types/AssetType";
import { impliedVolatilityTooltipService } from "../utils/ImpliedVolatilityTooltipService";
import {
    chartTooltipService
} from "../../../screens/portfolio-profile/components/charts/portfolio-greek-profile/services/ChartTooltipService";

type ImpliedVolatilityChartProps = {
    selectedExpiration: string;
    selectedOptionType: AssetType;
    selectedStrike: number;
}

export function ImpliedVolatilityChart({
    selectedExpiration,
    selectedOptionType,
    selectedStrike,
}: ImpliedVolatilityChartProps){
    const {
        marketDataDto,
        
    } = useAppContext();

    useEffect(() => {
    }, [marketDataDto]);
    
    const getXAxisName = (): string => 'Strike'; // 'Price\nCurrent\nCustom\nDelta\nVega\nTheta';

    const getAxisXFormattedLabel = (value: string, index: number) => {
        return value; // todo: extend it to have more informative axisXLabels
    }

    const intermediateStrikeStep = 25;
    
    const data: number[][] = chartDataSourceService.getData(marketDataDto, selectedExpiration, selectedOptionType, intermediateStrikeStep);
    const series: any[] = chartDataSeriesService.getChartSeries(marketDataDto!.UnderlyingPrice!, intermediateStrikeStep, data);
    
    const selectedCurrentLineColour = 'green'; // '#444444';
    const selectedCustomLineColour = '#ac0000'; // '#444444';
        
    return(
        <ReactEcharts
            theme="light"
            style={{
                // flex: '1',
                height: 400
            }}
            option={{
                grid: {
                    left: 50,
                    right: 0,
                    top: 10,
                    bottom: 20,
                },
                legend: {
                    show: false,
                    selected: {
                        "Implied Volatility": true,
                    },
                    top: 0,
                },
                tooltip: {
                    appendToBody: true,
                    trigger: 'axis',
                    showContent: true,
                    formatter: (params: any) => impliedVolatilityTooltipService
                        .getTooltipContent(data, params, marketDataDto!, selectedStrike),
                    position: chartTooltipService.getTooltipPositionForImpliedVolatilityChart(),
                    backgroundColor: 'rgba(50,50,50,0.95)',
                    borderColor: 'rgba(200,200,200,1)',
                    textStyle: {
                        color: 'rgba(200,200,200,1)'
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    position: 'bottom',
                    nameLocation: 'start',
                    name: getXAxisName(),
                    nameTextStyle: {
                        fontWeight: '500',
                        align: 'right',
                        verticalAlign: 'top',
                        padding: [8, 0, 0, 0],
                        fontSize: 12,
                    },
                    nameGap: 3,
                    axisLabel: {
                        formatter: getAxisXFormattedLabel,
                        rich: {
                            currentBalanceStyle: {
                                color: selectedCurrentLineColour,
                                fontWeight: 'semibold',
                            },
                            customBalanceStyle: {
                                color: selectedCustomLineColour,
                                fontWeight: 'semibold',
                            },
                        },
                        align: 'right',
                        fontSize: 12,
                        showMinLabel: false,
                        interval: 'auto',
                        // hideOverlap: true,
                        // width: 5
                    },
                    axisLine: {
                        'onZero': false,
                    },
                },
                yAxis: [
                    {
                        gridIndex: 0,
                        position: 'left',
                        axisLabel: {
                            formatter: (value: number, index: number) => {
                                return `${value.toFixed(1)}%`;
                            }
                        },
                        axisTick: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(200,200,200)'
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgb(200,200,200)'
                            },
                        },
                        minorSplitLine: {
                            show: true,
                            splitNumber: 5,
                            lineStyle: {
                                color: 'rgb(205,205,205)',
                                type: 'dotted'
                            }
                        },
                        scale: true
                    },
                ],
                dataZoom: [
                    {
                        show: true,
                        type: 'inside',
                        zoomOnMouseWheel: true,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: false,
                        filterMode: 'none',
                        xAxisIndex: [0],
                        startValue: 'min',
                        endValue: 'max',
                    },
                    {
                        show: true,
                        type: 'inside',
                        zoomOnMouseWheel: true,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: false,
                        filterMode: 'none',
                        yAxisIndex: [0],
                        startValue: 'min',
                        endValue: 'max',
                    }
                ],
                dataset: {
                    source: data,
                },
                series: series,
            }}
        />
    )
}